import { useSelectCurrentOrder } from '../../../selectors/order/selectCurrentOrder';
import {
  useListMethodsQuery,
  useListSigningAppointmentsQuery,
  useListStatusesQuery,
  useListTypesQuery,
} from '../../../API/order/signingAppointment/SigningAppointmentAPI';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';

export const useIsAppointmentListLoading = () => {
  const { orderId } = useParams<{ orderId: UUID; appointmentId?: UUID }>();

  const { fetchStatus: orderFetchStatus } = useSelectCurrentOrder();

  const { isLoading: signingTypesIsLoading } = useListTypesQuery();
  const { isLoading: signingMethodsIsLoading } = useListMethodsQuery();
  const { isLoading: signingStatusesIsLoading } = useListStatusesQuery();
  const { isLoading: signingAppointmentsIsLoading } = useListSigningAppointmentsQuery({
    orderId,
  });
  return (
    signingAppointmentsIsLoading ||
    signingStatusesIsLoading ||
    orderFetchStatus.fetching ||
    signingMethodsIsLoading ||
    signingTypesIsLoading
  );
};
